import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const ProgramsPresenterViewState = {
  COMPARE: {
    currentSortType: ''
  },
  FAVORITES: {
    currentSortType: 'name'
  },
  PROGRAMS: {
    currentSortType: 'rank'
  },
  SEARCH: {
    currentSortType: 'rank'
  }
};

angular
  .module('major-explorer-data')
  .constant('ProgramsPresenterViewState', Enumeration('ProgramsPresenterViewState', ProgramsPresenterViewState));



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/types/programs_presenter_view_state.ts